/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class DisableAccountSuccess extends React.Component<*> {
  componentDidMount() {
    if (this.props.accountStore && this.props.accountStore.specificUser) {
      this.props.accountStore.specificUser.account_user_enabled = 1; // eslint-disable-line camelcase
    }
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const account: Object = actionDrawerStore.response.account;
    const user: Object = actionDrawerStore.response.users[0];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:trading_accounts.access_enabled')}</h3>
            <p>{t('general:trading_accounts.messages.access_enabled', { title: account.name })}</p>
          </div>
          <div className={styles['enable-account-details']}>
            <ul>
              <li>{`${user.first_name} ${user.last_name}`}</li>
              <li>
                <b>{t('general:roles.labels.current_role')}</b>: {user.role}
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
